import styled from "styled-components";

export const PageTitle = styled.h4`
  border-bottom: 5px solid ${props => props.theme.color};
`;
